import { ConsentMode } from 'features/globalSetup/types/workspaceBidder'

export const DEFAULT_CPM_ADJUSTMENT = 100

export const DEFAULT_CONSENT_MODE: ConsentMode = 'consentOnly'

export const SELECT_HINT_LEARN_MORE =
  'https://knowledge-base.yieldbird.com/frequently-asked-questions/what-should-i-do-if-the-prebid-adapter-i-need-isnt-supported'

export const BIDDER_CONFIG_LEARN_MORE =
  'https://knowledge-base.yieldbird.com/prebid-stack/bidders#block-21c61213c49b808daeb5d1a7c70189dd'
